// extracted by mini-css-extract-plugin
export default {"countdown":"smallCountDown_countdown__mU9xe"};